<template>
  <div
    class="py-10 md:py-20 px-4"
    :data-testid="props.dataTestid"
  >
    <div class="faq mx-auto max-w-wrapper-md">
      <V2AtomsHighlight
        v-if="title"
        size="large"
        :class="{ 'mb-2 md:mb-4': $slots.default }"
      >
        {{ title }}
      </V2AtomsHighlight>

      <div
        v-if="$slots.default"
        class="md:text-lg/[150%] text-semantic-surface-on-surface"
      >
        <slot />
      </div>

      <div
        v-if="list && list.length > 0"
        class="faq__list md:mt-10 mt-6"
      >
        <V2MoleculesAccordion
          v-for="(item, itemIndex) in list"
          ref="faqItems"
          :key="itemIndex"
          :title="item.title"
          :content="item.content"
        />
      </div>

      <div
        v-if="$slots.footer"
        :class="{ 'md:mt-10 mt-6': $slots.footer }"
        class="md:text-lg/[150%] text-semantic-surface-on-surface"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2OrganismFaq'
})

const $route = useRoute()
const $attrs = useAttrs()

const props = defineProps({
  dataTestid: {
    type: String,
    default: 'faq'
  },

  title: {
    type: String,
    default: ''
  },

  list: {
    type: Array,
    default: () => []
  },

  hideSchema: {
    type: Boolean,
    default: false
  }
})

useJsonld(() => {
  if (
    props.list.length < 1 ||
    props.hideSchema ||
    ($attrs.id && $attrs.id !== 'faq')
  ) {
    return null
  }

  return GENERATE_FAQ_SCHEMA({
    faqs: props.list,
    page: $route.path
  })
})
</script>
